<h1 mat-dialog-title class="title align-self-center text-center">Please select an option</h1>
<div mat-dialog-content>
  <!-- <mat-form-field appearance="fill"> -->
    <div *ngFor="let extra of data.extras">
      <button mat-button class="extras-button" (click)="onChosenExtra(extra)">{{extra.title}} - £{{getTotalPrice(extra.price) | number : '1.2-2'}}</button>
    </div>
    <!-- <input matInput [(ngModel)]="data.animal"> -->
  <!-- </mat-form-field> -->
</div>
<!-- <div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No Thanks</button>
  <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button>
</div> -->
